import { css } from '@/styled-system/css';

export const totalPriceBadge = css({
  alignItems: 'center',
  display: 'inline-flex',
  gap: 'tightest',
});

/** Wrapper that pairs the CircleCheck icon with the TriggerText button. */
export const totalPriceTriggerWrapper = css({
  alignItems: 'center',
  display: 'inline-flex',
  gap: 'tightest',
});

export const totalPriceIcon = css({
  color: 'text.accent.brand.hero',
  fill: 'currentColor',
  flexShrink: 0,
  stroke: 'white',
});

export const totalPriceLabel = css({
  color: 'text.accent.brand.hero',
  fontSize: 'body',
  fontWeight: 'normal',
  lineHeight: 'body',
});

export const feesApply = css({
  color: 'text.subtle',
  fontSize: 'body',
  fontWeight: 'normal',
  lineHeight: 'body',
});

export const notice = css({
  alignItems: 'center',
  backgroundColor: 'bg.softest',
  borderRadius: 'md',
  color: 'text.subtle',
  display: 'flex',
  fontSize: 'body-sm',
  gap: 'tighter',
  lineHeight: 'body-sm',
  paddingBlock: 'tighter',
  paddingInline: 'default',
});

export const noticeIcon = css({
  flexShrink: 0,
});
